import axios from "./axios";

class NsdlPanCardService {
  getAuthorization = async (
    applicationMode,
    applicationType,
    category,
    name,
    dob,
    gender,
    mobile,
    email,
    isPhyPanRequired,
  ) => {
    try {
      const response = await axios.post("/nsdl_pancard/get_authorization", {
        application_type: applicationType,
        category: category,
        name: name,
        dob: dob,
        gender: gender,
        mobile: mobile,
        email: email,
        is_physical_pan_required: isPhyPanRequired,
        application_mode: applicationMode,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  serviceStatus = async () => {
    try {
      const response = await axios.post("/nsdl_pancard/service_status", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchCommercial = async () => {
    try {
      const response = await axios.post("/nsdl_pancard/fetch_commercial", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  panStatus = async (ack_no) => {
    try {
      const response = await axios.post("/nsdl_pancard/check_status", {
        ack_no: ack_no,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getIncompleteUrl = async (order_id) => {
    try {
      const response = await axios.post("/nsdl_pancard/get_incomplete_url", {
        order_id: order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  history = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page,
  ) => {
    try {
      const response = await axios.post("/nsdl_pancard/report", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  nsdlResponse = async (encrypted_data) => {
    try {
      const response = await axios.post("/nsdl_pancard/response", {
        encrypted_data,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
  downloadCertificate = async () => {
    try {
      const response = await axios.post(
        "/nsdl_pancard/download_certificate",
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob", // 👈 IMPORTANT
        },
      );

      return response.data; // PDF blob
    } catch (error) {
      let message = "Failed to download certificate";

      if (error.response && error.response.data) {
        try {
          // 👇 Convert blob error to text
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          message = json.message || message;
        } catch (e) {
          // fallback
          message = "Download failed";
        }
      }

      throw new Error(message);
    }
  };
}
export default new NsdlPanCardService();
